import React from 'react';
import { validated } from 'react-custom-validation';
import PropTypes from 'prop-types';
import update from 'immutability-helper';

import { isEqual, isRequired } from 'utils/validations';

import Button from 'components/Button';
import Form from 'components/Form';
import FormValidationMessage from 'components/FormValidationMessage';
import FormRow from 'components/FormRow';
import LoadingCircle from 'components/LoadingCircle';
import Textbox from 'components/Textbox';

class ResetPasswordForm extends React.Component {
    static propTypes = {
        error: PropTypes.object.isRequired,
        isResettingPassword: PropTypes.bool.isRequired,
        onValid: PropTypes.func.isRequired,
        onInvalid: PropTypes.func.isRequired,
        resetPasswordData: PropTypes.object.isRequired,
        setResetPasswordData: PropTypes.func.isRequired
    };

    _handleChange(event) {
        let newDataObj = update(this.props.resetPasswordData, {});
        newDataObj[event.target.name] = event.target.value;
        this.props.setResetPasswordData(newDataObj);
    }

    render() {
        let { isResettingPassword, onValid, onInvalid, resetPasswordData, $field, $validation } = this.props;
        return (
            <Form>
                <FormRow>
                    <Textbox
                        id="txtPassword"
                        label="New Password"
                        name="password"
                        placeholder="Your new password"
                        type="password"
                        validation={$validation.password}
                        value={resetPasswordData.password}
                        {...$field('password', (event) => this._handleChange(event))}
                    />
                </FormRow>
                <FormRow>
                    <Textbox
                        id="txtPassword2"
                        label="Confirm Password"
                        name="password2"
                        placeholder="Confirm your password"
                        type="password"
                        validation={$validation.password2}
                        value={resetPasswordData.password2}
                        {...$field('password2', (event) => this._handleChange(event))}
                    />
                </FormRow>
                {Object.keys(this.props.error).length > 0 ? (
                    <FormRow className="error-message">
                        <FormValidationMessage>
                            {this.props.error.friendlyMessage || this.props.error.message}
                        </FormValidationMessage>
                    </FormRow>
                ) : null}
                <FormRow className="button-wrapper">
                    <Button type="submit"
                            disabled={isResettingPassword}
                            onClick={(event) => {
                                event.preventDefault();
                                this.props.$submit(onValid, onInvalid);
                            }}>
                        Change Password
                        {isResettingPassword === true ? <LoadingCircle outerColor="#ffffff" /> : null}
                    </Button>
                </FormRow>
            </Form>
        )
    }
}

function resetPasswordFormValidationConfig(props) {
    const { password, password2 } = props.resetPasswordData;

    return {
        fields: ['password', 'password2'],
        validations: {
            password: [
                [isRequired, password]
            ],
            password2: [
                [isRequired, password2],
                [isEqual, password, password2, 'Passwords must match']
            ]
        }
    }
}

export default ResetPasswordForm = validated(resetPasswordFormValidationConfig)(ResetPasswordForm);



// WEBPACK FOOTER //
// ./src/containers/Auth/ResetPasswordPage/ResetPasswordForm.js